import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import time from 'yoda-core-components/lib/moment/Time';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import ChevronDown from 'yoda-core-components/lib/assets/icons/navigation/chevron-down.svg';
import ChevronUp from 'yoda-core-components/lib/assets/icons/navigation/chevron-up.svg';

const RewardsHistoryRow = ({ historyData, index, messagesTexts }) => {
    const [showDetails, setShowDetails] = useState(false);

    const { certValue, percentOff, statusDescription, expiryDate, issueDate, typeDescription, usedDate, status } = historyData;
    const displayCertValue = percentOff === true ? `${certValue}%` : `$${certValue}`;

    const STATUS_COLOR_MAP = {
        Available: dt(['text-[#2E7D32]']),
        Redeemed: dt(['text-[#2E7D32]']),
        Expired: dt(['text-[#E71324]']),
    };
    const statusLabel = (messagesTexts?.rewardsHistory?.typeStatus?.[status]) || status || '';
    const statusColorClass = STATUS_COLOR_MAP[statusLabel] || dt(['text-black']);
    let expiresInStr = '';
    if (historyData.expiresIn || historyData.expiresIn === 0) {
        expiresInStr = historyData.expiresIn.toString();
    }
    const isEarned = statusDescription === 'Reward Earned';
    const isRedeemed = statusDescription === 'Reward Redeemed';

    const daysLabel = expiresInStr !== '1' ? 'days' : 'day';
    const daysLeft = expiresInStr !== '0'
        ? `${expiresInStr} ${daysLabel} left!`
        : 'Expires today!';

    return (
        <div
            key={index}
            className={dt([
                'flex', 'flex-col', 'md:flex-row', 'md:justify-between',
                'border-b', 'border-solid', 'border-[#D8D8D8]',
                'bg-white',
            ])}
        >
            {/* Left: date + type + expandable details */}
            <div className={dt(['flex', 'flex-col', 'pt-4', 'px-4', 'pb-4', 'gap-1'])}>
                <span className={dt(['text-small', 'text-black', 'flex', 'flex-col'])}>
                    <b className={dt(['text-black'])}>Expiration Date:</b>
                    {time(expiryDate).format('MMM DD, YYYY')}
                </span>
                {isEarned && expiresInStr !== '' && (
                    <span className={dt(['text-small', 'text-[#E71324]', 'font-semibold'])}>
                        {daysLeft}
                    </span>
                )}
                {isRedeemed && usedDate && (
                    <span className={dt(['text-small', 'text-[#4D4D4D]'])}>
                        Used on {usedDate}
                    </span>
                )}
                <button
                    type="button"
                    className={dt(['flex', 'items-center', 'gap-1', 'text-small', 'text-black', 'mt-1'])}
                    onClick={() => setShowDetails((prev) => !prev)}
                    automationid="at-rewards-details-btn"
                >
                    {showDetails ? 'Less Details' : 'More Details'}
                    <Icon iconType="svg" width="16px" height="16px" viewBox="0 0 20 20">
                        {showDetails ? <ChevronUp /> : <ChevronDown />}
                    </Icon>
                </button>
                {showDetails && (
                    <div className={dt(['flex', 'flex-col', 'gap-1', 'pt-1', 'text-small', 'text-[#4D4D4D]'])}>
                        <span className={dt(['flex', 'flex-col'])}>
                            <b className={dt(['text-black'])}>Issue Date:</b>
                            {time(issueDate).format('LL')}
                        </span>
                        {isRedeemed && usedDate && (
                            <span className={dt(['flex', 'flex-col'])}>
                                <b className={dt(['text-black'])}>Used on:</b>
                                {usedDate}
                            </span>
                        )}
                        <span className={dt(['flex', 'flex-col'])}>
                            <b className={dt(['text-black'])}>Rewards Type:</b>
                            {typeDescription}{typeDescription !== 'JCP BONUS BUCK$' ? ' Reward' : ''} 1 x {displayCertValue}
                        </span>
                        <span className={dt(['flex', 'flex-col'])}>
                            <b className={dt(['text-black'])}>Status:</b>
                            <b className={statusColorClass}>{statusLabel}</b>
                        </span>
                    </div>
                )}
            </div>

            {/* Right: value — gray-05 bg */}
            <div className={dt([
                'flex', 'flex-row', 'md:flex-col', 'justify-between', 'md:justify-center', 'items-center',
                'py-3', 'px-4', 'bg-[#F2F2F2]', 'md:min-w-[80px]',
            ])}>
                <span className={dt(['font-semibold', 'text-small', 'text-black', 'leading-5'])}>
                    {isRedeemed || statusDescription === 'Reward Expired' ? '-' : ''}{displayCertValue}
                </span>
                <span className={dt(['text-small', 'text-[#4D4D4D]', 'leading-5'])}>
                    Value
                </span>
            </div>
        </div>
    );
};

const NewHistoryData = ({ data, messagesTexts }) => {
    const rows = data || [];
    return (
        <div className={dt(['w-full', 'border-t', 'border-solid', 'border-[#D8D8D8]'])}>
            {rows.map((item, i) => (
                <RewardsHistoryRow key={i} historyData={item} index={i} messagesTexts={messagesTexts} /> // eslint-disable-line react/no-array-index-key
            ))}
        </div>
    );
};

NewHistoryData.propTypes = {
    data: PropTypes.array.isRequired,
    messagesTexts: PropTypes.object.isRequired,
};

export default NewHistoryData;
